import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import useCommonStore from 'store/common';
import './style.scss';
import useTranslate from 'hooks/useTranslate';

const NotificationDetail = () => {
	const { translate } = useTranslate();
	const { modalConfig = {}, hideCommonModal }: any = useCommonStore((state) => state);

	return (
		<Modal.Body className="p-30 pe-0">
			<Button
				className="close-btn rounded-circle border-0 fw-bold position-absolute"
				onClick={() => {
					hideCommonModal();
				}}
			>
				<i className="ri-close-line"></i>
			</Button>
			<div className="notification-detail">
				<div className=" notification-detail-header">
					<h4>{translate('Common.notification')}</h4>
				</div>
				<div className="notification-detail-body">{modalConfig?.data?.message}</div>
			</div>
		</Modal.Body>
	);
};

export default NotificationDetail;
